import { render, staticRenderFns } from "./PlanBasedPricing.vue?vue&type=template&id=58117724&scoped=true&"
import script from "./PlanBasedPricing.vue?vue&type=script&lang=js&"
export * from "./PlanBasedPricing.vue?vue&type=script&lang=js&"
import style0 from "./PlanBasedPricing.vue?vue&type=style&index=0&id=58117724&lang=scss&scoped=true&"
import style1 from "./PlanBasedPricing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58117724",
  null
  
)

export default component.exports